<div class="pull-left text-muted" ng-show="(history || data.activity).data">
  <i class="fa fa-calendar" aria-hidden="true"></i>
  <strong ng-show="tipo != 'stand'">até </strong>{{(history || data.activity).data | date:'dd/MM/yyyy'}}
</div>
<button type="button" title="Imprimir" class="btn btn-sm pull-right btn-link" ng-click="print()">
  <i class="fa fa-print"></i>
</button>
<div class="clearfix"></div>

<div class="title text-center">
  <h2>
    <strong>CONTAGEM STAND</strong>
  </h2>
</div>

<div class="btn-group" uib-dropdown ng-show="tipo == 'stand'">
  <button type="button" class="btn btn-white btn-sm" uib-dropdown-toggle>
     {{(details.markers[0].marker || details.markers[0].objeto).cultivarForGroup.descricao | characters:30}} <span class="caret"></span>
  </button>
  <ul class="dropdown-menu-right" uib-dropdown-menu role="menu">
    <li role="menuitem" ng-repeat="(key, value) in cultivaresMarker">
      <a ng-click="getSummary(value, $event)" href="#">{{(value[0].marker || value[0].objeto).cultivarForGroup.descricao | characters:30}}</a>
    </li>
  </ul>
</div>

<div>
  <i class="icon-culture" aria-hidden="true"></i>
    <small class="text-italic">
      {{tipo !== 'stand' ? ((details.markers[0].marker || details.markers[0].objeto).cultivarForGroup.descricao) + ' -' : '' }}
      Plantio:
      <plantio safra="details.markers[0].objeto.params.safra_id" gleba="details.markers[0].objeto.params.gleba_id" insumo="details.markers[0].objeto.params.cd_insumo"/>
    </small>
</div>

<div ng-show="details.quantidade">
  <span ng-show="!details.atividade.isCana">
    <h3><strong>Densidade (plantas/ha)</strong></h3>
    <table class="table">
      <tr>
        <td><strong>Ideal</strong></td>
        <td class="text-right">
          {{(details.ideal || 0) | number:0}}
          <span class="pointer" ng-if="$root.permissions.contagem.canEditDensity" ng-click="changeIdealDensity()"><i class="fa fa-pencil-square" aria-hidden="true"></i></span>
        </td>
      </tr>
      <tr>
        <td><strong>Contada</strong></td>
        <td class="text-right">{{details.media | number:0}}</td>
      </tr>
      <tr>
        <td><strong>Variação (&#916;%)</strong></td>
        <td class="text-right">{{details.variacao | number:2}}</td>
      </tr>
    </table>

    <div ng-show="hasInformedDistance()">
      <h3><strong>Distribuição</strong></h3>
      <table class="table">
        <tr ng-if="details.atividade.isCorn">
          <td><strong>Ausentes</strong></td>
          <td class="text-right">
          {{details.media_ausentes_percentual | number:2}}%
          <i class="icon-info text-muted" aria-hidden="true"
              uib-tooltip-template="'tooltip-absents.html'"
              tooltip-placement="left" tooltip-append-to-body="true"></i>
          </td>
        </tr>
        <tr ng-if="details.atividade.isCorn">
          <td><strong>Duplas</strong></td>
          <td class="text-right">{{details.media_duplas_percentual | number:2}}%</td>
        </tr>
        <tr ng-if="details.atividade.isCorn">
          <td><strong>Dominadas</strong></td>
          <td class="text-right">{{details.media_dominadas_percentual | number:2}}%</td>
        </tr>
        <span ng-if="hasInformedDistance()">
          <tr>
            <td><strong>Uniformidade (CV)</strong></td>
            <td class="text-right">{{uniformidadeDistribuicaoAverage() | number:2}}%</td>
          </tr>
          <tr>
            <td><strong>Média  de Plantas Inconformes na Pos. Ideal</strong></td>
            <td class="text-right">{{plantasInconformesAverage() | number:2}}%</td>
          </tr>
        </span>
      </table>
      <div id="chartDistribution" class="chart-points">
        <div id="containerChartDistribution" class="height-100 width-100"></div>
      </div>
      <table class="table">
        <thead>
          <tr>
            <th>Ponto</th>
            <th class="text-right">CV</th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="point in details.markers track by point.objeto.registroId"
              ng-mouseleave="resetAnimationMarker(point)"
              ng-mouseover="setAnimationMarker(point)"
              ng-class="{'info': point.id == indexMarker, 'activate-line': point.marker.isOpen || point.leafletMarker.isPopupOpen(), 'inactive-row' : !point.objeto.registroAtivo}"
              ng-click="openMarkerInfoWindow(point)"
              class="pointer"
              ng-show="point.objeto.uniformidadeDistribuicao">
            <td>Ponto {{$index + 1}}</td>
            <td class="text-right">{{(point.marker || point.objeto).uniformidadeDistribuicao | number:2}}%</td>
          </tr>
        </tbody>
      </table>
    </div>

    <h3><strong>Detalhamento</strong></h3>
    <table class="table">
      <tr>
        <td><strong>Nº de Amostras</strong></td>
        <td class="text-right">{{details.quantidade}}</td>
      </tr>
      <tr>
        <td><strong>Maior</strong></td>
        <td class="text-right">{{details.maxima | number:0}}</td>
      </tr>
      <tr>
        <td><strong>Menor</strong></td>
        <td class="text-right">{{details.minima | number:0}}</td>
      </tr>
    </table>

    <div id="chartStand" class="chart-points">
      <div id="containerChartStand" class="height-100 width-100"></div>
    </div>

    <table class="table">
      <thead>
        <tr>
          <th colspan="2">Faixas de Variação(&#916;%)</th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="(key, faixa) in details.faixas track by $index">
          <td>
            <span class="bg-{{ faixa.status }}">&nbsp;&nbsp;&nbsp;</span>
            <strong>{{key}}</strong>
          </td>
          <td>
            <ng-pluralize count="{{faixa.quantidade}}"
                when="{'0': 'sem registros',
                       'one': '{{faixa.quantidade}} ponto ({{faixa.percentual  | number:0 }}%)',
                       'other': '{{faixa.quantidade}} pontos ({{faixa.percentual  | number:0 }}%)'}">
            </ng-pluralize>
          </td>
        </tr>
      </tbody>
    </table>
  </span>
  <span ng-show="details.atividade.isCana">
    <h3><strong>Densidade </strong></h3>
    <table class="table">
      <tr>
        <td><strong>Área total média</strong></td>
        <td class="text-right">
          {{(details.medias_cana.media_area_total || 0) | number:0}}
        </td>
      </tr>
      <tr>
        <td><strong>Área de Cana média por ha </strong></td>
        <td class="text-right">{{details.medias_cana.media_area | number:0}}</td>
      </tr>
    </table>

    <h3><strong>Detalhamento</strong></h3>
    <table class="table">
      <tr>
        <td><strong>Nº de Amostras</strong></td>
        <td class="text-right">{{details.quantidade}}</td>
      </tr>
      <tr>
        <td><strong>Maior</strong></td>
        <td class="text-right">{{details.medias_cana.media_area_maxima | number:0}}</td>
      </tr>
      <tr>
        <td><strong>Menor</strong></td>
        <td class="text-right">{{details.medias_cana.media_area_minima | number:0}}</td>
      </tr>
    </table>

  </span>

</div>

<span ng-show="!details.atividade.isCana">
  <table class="table">
    <thead>
      <tr>
        <th>Ponto</th>
        <th class="text-right">pl/ha</th>
        <th class="text-right">Variação</th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat="point in details.markers | orderBy: 'objeto.created_at' track by $index"
          ng-mouseleave="resetAnimationMarker($index)"
          ng-mouseover="setAnimationMarker($index)"
          ng-class="{'info': $index == indexMarker, 'activate-line': point.marker.isOpen || point.leafletMarker.isPopupOpen(), 'inactive-row' : !point.objeto.registroAtivo}"
          ng-click="openMarkerInfoWindow($index)" class="pointer">
        <td>Ponto {{$index + 1}}</td>
        <td class="text-right">{{(point.marker || point.objeto).realized | number:0}}</td>
        <td class="text-right">{{(point.marker || point.objeto).variation | number:2}}%</td>
      </tr>
    </tbody>
  </table>
</span>
<span ng-show="details.atividade.isCana">
  <table class="table">
    <thead>
      <tr>
        <th>Ponto</th>
        <th class="text-right">Média de Falhas</th>
        <th class="text-right">Área de Cana Média</th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat="point in details.markers | orderBy: 'objeto.created_at' track by $index"
          ng-mouseleave="resetAnimationMarker($index)"
          ng-mouseover="setAnimationMarker($index)"
          ng-class="{'info': $index == indexMarker, 'activate-line': point.marker.isOpen || point.leafletMarker.isPopupOpen(), 'inactive-row' : !point.objeto.registroAtivo}"
          ng-click="openMarkerInfoWindow($index)" class="pointer">
        <td>Ponto {{$index + 1}}</td>

        <td class="text-right">{{(point.marker || point.objeto).avg_flaws | number:1}}</td>
        <td class="text-right">{{(point.marker || point.objeto).avg_flaw_area | number:0}}</td>
      </tr>
    </tbody>
  </table>
</span>

<span ng-show="!details.atividade.isCana">
  <script type="text/ng-template" id="tooltip-absents.html">
    <span>
      O percentual de plantas ausentes é calculado por meio da soma das plandas emergidas ({{details.media | number:0}} pl/ha) com as falhas ({{details.media_ausentes | number:0}} pl/ha).
    </span>
  </script>
</span>

<span ng-show="!details.atividade.isCana">
<!-- Botão para ser chamar impressão, só pode ser chamado depois de carregar os dados da função print() -->
<button id="hidden-print" ng-print print-element-id="print-stand" class="hidden"></button>

<div id="print-stand" class="only-print" ng-if="report.ready">
  <h2>{{details.gleba.descricao}}</h2>
  <h3>Contagem Stand de {{details.atividade.descricao}} <small>{{(report.pontos[0].marker || report.pontos[0].objeto).cultivarForGroup.descricao}}</small></h3>

  <p>Data de semeadura: {{report.plantio.inicio | date:'dd/MM/yy'}} <span ng-if="report.plantio.inicio != report.plantio.fim">{{report.plantio.fim | date:'dd/MM/yy'}}</span></p>
  <p>Data de emergência: {{report.informacaoCultivar.data_emergencia | date:'dd/MM'}}</p>
  <p>Data contagem: {{getPeriodo(details).fim | date: 'dd/MM'}} </p>
  <p>Área: {{report.plantio.area | number:1}}ha</p>
  <p>Densidade ideal: {{(details.ideal || 0) | number:0}}</p>
  <p>População: {{details.media | number:0}} pl/ha | {{(details.media / 10000) | number:0}} pl/m²</p>
  <p>Variação: {{details.variacao | number:2}}%</p>
  <p>Responsável pela contagem: {{report.responsaveis}}</p>
  <br />
  <h4>Pontos</h4>
  <table class="table table-bordered">
    <thead>
      <tr>
        <th class="col-md-1 text-center">Ponto</th>
        <th class="text-right col-md-2">Média</th>
        <th class="text-right col-md-2">Variação</th>
        <th class="first-line" colspan="10">Linhas</th>
      </tr>
      <td>
        <td colspan="2"></td>
        <td ng-class="{'first-line': $first}" class="col-md-1 text-left line-value" ng-repeat="index in [].constructor(report.maxLines) track by $index"><b>{{$index+1}}</b></td>
      </td>
    </thead>
    <tbody>
      <tr ng-repeat="point in report.pontos | orderBy: 'objeto.created_at' track by $index">
        <td class="col-md-1 text-center">{{$index + 1}}</td>
        <td class="col-md-2 text-right">{{(point.marker || point.objeto).realized | number:0}}</td>
        <td class="col-md-2 text-right">{{(point.marker || point.objeto).variation | number:2}}%</td>
        <td class="col-md-1 text-left line-value" ng-class="{'first-line': $first}" ng-repeat="line in point.objeto.lines">
          {{line.plants}}
        </td>
        <td ng-repeat="index in [].constructor(report.maxLines - point.objeto.lines.length) track by $index">&nbsp;</td>
      </tr>
    </tbody>
  </table>
  <small class="text-right">Gerado na plataforma Aqila em {{report.date | date:'dd/MM/yy HH:mm'}}</small>
</div>
</span>

<span ng-show="details.atividade.isCana"></span>
<!-- Botão para ser chamar impressão, só pode ser chamado depois de carregar os dados da função print() -->
<button id="hidden-print-cana" ng-print print-element-id="print-stand-cana" class="hidden"></button>

<div id="print-stand-cana" class="only-print" ng-if="report.ready">
  <h2>{{details.gleba.descricao}}</h2>
  <h3>Contagem Stand de {{details.atividade.descricao}} <small>{{(report.pontos[0].marker || report.pontos[0].objeto).cultivarForGroup.descricao}}</small></h3>

  <p>Data de semeadura: {{report.plantio.inicio | date:'dd/MM/yy'}} <span ng-if="report.plantio.inicio != report.plantio.fim">{{report.plantio.fim | date:'dd/MM/yy'}}</span></p>
  <p>Data de emergência: {{report.informacaoCultivar.data_emergencia | date:'dd/MM'}}</p>
  <p>Data contagem: {{getPeriodo(details).fim | date: 'dd/MM'}} </p>
  <p>Área: {{report.plantio.area | number:1}}ha</p>
  <p>Área total média: {{(details.media_area_total || 0) | number:0}}</p>
  <p>Área média de cana por ha: {{details.media_area | number:0}} </p>
  <p>Responsável pela contagem: {{report.responsaveis}}</p>
  <br />
  <h4>Pontos</h4>
  <table class="table table-bordered">
    <thead>
      <tr>
        <th class="col-md-1 text-center">Ponto</th>
        <th class="text-right col-md-2">Média de falhas</th>
        <th class="text-right col-md-2">Área de cana média por ha</th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat="point in report.pontos | orderBy: 'objeto.created_at' track by $index">
        <td class="col-md-1 text-center">{{$index + 1}}</td>
        <td class="col-md-2 text-right">{{(point.marker || point.objeto).avg_flaws | number:0}}</td>
        <td class="col-md-2 text-right">{{(point.marker || point.objeto).avg_flaw_area | number:2}}</td>
      </tr>
    </tbody>
  </table>
  <small class="text-right">Gerado na plataforma Aqila em {{report.date | date:'dd/MM/yy HH:mm'}}</small>
</div>
</span>
